export enum InvitePoints {
  GET_CURRENT_USERS = 'profile/invite/users/get',
  GET_IVITE_SEARCH = 'invite/get',
  POST_IVITE_CREATE = 'profile/invite/create',
  POST_IVITE_REGISTER = 'profile/invite/register',
}

export interface CreateInvite {
  email: string;
  last_name: string;
  first_name: string;
  phone: string;
  municipality_id: string;
  snils: string;
}

export interface CreatePassword {
  password: string;
  code: string;
}



// WEBPACK FOOTER //
// ./src/services/invite/types.ts